/* eslint-disable camelcase */
// WindMachine.jsx
/*

  settings to account for

  - [X] auto
  - [X] program (application)
  - [x] analog inputs
    - [x] mode
    - [x] test 1
    - [x] test 2
  - [x] digital inputs
    - [x] mode
  - [x] com source
  - [X] schedule

*/

import React, { useState, useEffect, useCallback } from 'react'
import { FormattedMessage, injectIntl } from 'react-intl'
import PropTypes from 'prop-types'
import updateRA from 'immutability-helper'
import moment from 'moment'
import Highcharts from 'highcharts'
import { Chart as HighchartsReact } from '@highcharts/react'
import { round } from 'altrac-conversions'
import { DecimalInput, SelectInput, isNumber } from '../Inputs/Inputs'

import AppDispatcher from '../../../dispatchers/AppDispatcher'

import styles from '../../../../css/settings.module.css'
import stylesTele from '../../../../css/telemetry.module.css'

const DEFAULT_SETTINGS = {
  calibrate1: 1,
  calibrate2: 1,
}

const DEFAULT_PHYSICAL = {
  windMachineMake: '',
  windMachineEngine: '',
  windMachineMultiplier: 1,
  rpmMultiplier: 1,
  rpmCalibration: 'Default',
  ctmEnabled: 'No CTM',
}

function DefaultEngineOptions (_newState, formatMessage) {
  const WINDMACHINE_ENGINE_ORCHARDRITE = [
    {
      name: formatMessage({
        id: 'setting.windMachine.select.engine',
        defaultMessage: 'Select Engine',
        description: '',
      }),
      value: '',
    },
    { name: '454/460', value: '454/460' },
    { name: 'Ford V10', value: 'V10' },
    { name: 'Ford V8 6.2L', value: 'V8 6.2' },
    { name: 'Ford V8 7.3L', value: 'V8 7.3' },
    { name: 'CAT 7.1', value: 'CAT 7.1' },
    { name: 'CAT 6.6', value: 'CAT 6.6' },
    { name: 'CAT 4.4', value: 'CAT 4.4' },
  ]

  const WINDMACHINE_ENGINE_AMARILLO = [
    {
      name: formatMessage({
        id: 'setting.windMachine.select.engine',
        defaultMessage: 'Select Engine',
        description: '',
      }),
      value: '',
    },
    { name: 'Ford V10', value: 'V10' },
    { name: 'Ford V8 6.2L', value: 'V8 6.2' },
    { name: 'Ford V8 7.3L', value: 'V8 7.3' },
    { name: 'IVECO', value: 'IVECO' },
  ]

  const WINDMACHINE_ENGINE_CHINOOK = [
    {
      name: formatMessage({
        id: 'setting.windMachine.select.engine',
        defaultMessage: 'Select Engine',
        description: '',
      }),
      value: '',
    },
    { name: 'Ford V10', value: 'V10' },
    { name: 'Ford V8 7.3L', value: 'V8 7.3' },
    { name: 'JCB', value: 'JCB' },
    { name: 'IVECO', value: 'IVECO' },
  ]

  const WINDMACHINE_ENGINE_VAMCO = [
    {
      name: formatMessage({
        id: 'setting.windMachine.select.engine',
        defaultMessage: 'Select Engine',
        description: '',
      }),
      value: '',
    },
    { name: 'Ford V10', value: 'V10' },
    { name: 'Ford V8 6.2L', value: 'V8 6.2' },
    { name: 'Ford V8 7.3L', value: 'V8 7.3' },
    { name: '454/460', value: '454/460' },
  ]

  const WINDMACHINE_ENGINE_WENATCHEE = [
    {
      name: formatMessage({
        id: 'setting.windMachine.select.engine',
        defaultMessage: 'Select Engine',
        description: '',
      }),
      value: '',
    },
    { name: 'Ford V10', value: 'V10' },
    { name: 'Ford V8 6.2L', value: 'V8 6.2' },
    { name: 'Ford V8 7.3L', value: 'V8 7.3' },
  ]

  const WINDMACHINE_ENGINE_FROSTBOSS = [
    {
      name: formatMessage({
        id: 'setting.windMachine.select.engine',
        defaultMessage: 'Select Engine',
        description: '',
      }),
      value: '',
    },
    { name: 'Diesel', value: 'Diesel' },
  ]

  const WINDMACHINE_ENGINE_JACKRABBIT = [
    {
      name: formatMessage({
        id: 'setting.windMachine.select.engine',
        defaultMessage: 'Select Engine',
        description: '',
      }),
      value: '',
    },
    {
      name: formatMessage({
        id: 'setting.windMachine.select.engine.standard',
        defaultMessage: 'Standard',
        description: '',
      }),
      value: 'Standard',
    },
  ]

  const WINDMACHINE_ENGINE_ELECTRIC = [
    {
      name: formatMessage({
        id: 'setting.windMachine.select.engine',
        defaultMessage: 'Select Engine',
        description: '',
      }),
      value: '',
    },
    {
      name: formatMessage({
        id: 'setting.windMachine.select.engine.electric',
        defaultMessage: 'Electric',
        description: '',
      }),
      value: 'Electric',
    },
  ]

  let newState

  if (_newState.windMachine_make === 'Amarillo') {
    newState = updateRA(_newState, {
      defaultEngine_options: { $set: WINDMACHINE_ENGINE_AMARILLO },
    })
  } else if (_newState.windMachine_make === 'Orchard Rite') {
    newState = updateRA(_newState, {
      defaultEngine_options: { $set: WINDMACHINE_ENGINE_ORCHARDRITE },
    })
  } else if (_newState.windMachine_make === 'Chinook') {
    newState = updateRA(_newState, {
      defaultEngine_options: { $set: WINDMACHINE_ENGINE_CHINOOK },
    })
  } else if (_newState.windMachine_make === 'Vamco') {
    newState = updateRA(_newState, {
      defaultEngine_options: { $set: WINDMACHINE_ENGINE_VAMCO },
    })
  } else if (_newState.windMachine_make === 'Jackrabbit') {
    newState = updateRA(_newState, {
      defaultEngine_options: { $set: WINDMACHINE_ENGINE_JACKRABBIT },
    })
  } else if (_newState.windMachine_make === 'Wenatchee') {
    newState = updateRA(_newState, {
      defaultEngine_options: { $set: WINDMACHINE_ENGINE_WENATCHEE },
    })
  } else if (_newState.windMachine_make === 'Frost Boss') {
    newState = updateRA(_newState, {
      defaultEngine_options: { $set: WINDMACHINE_ENGINE_FROSTBOSS },
    })
  } else if (_newState.windMachine_make === 'Electric') {
    newState = updateRA(_newState, {
      defaultEngine_options: { $set: WINDMACHINE_ENGINE_ELECTRIC },
    })
  } else {
    newState = updateRA(_newState, {
      defaultEngine_options: {
        $set: [
          {
            name: formatMessage({
              id: 'setting.windMachine.select.engine',
              defaultMessage: 'Select Engine',
              description: '',
            }),
            value: '',
          },
        ],
      },
    })
  }

  return newState
}

function Graph (props) {
  const {
    deviceReading,
    disableCalibration,
    calibrate1,
    calibrate2,
    rpmMultiplier,
    formatMessage,
  } = props

  const chartData = []

  deviceReading
    .sort((a, b) => {
      const dateA = new Date(a.date)
      const dateB = new Date(b.date)
      return dateA - dateB
    })
    .forEach((item) => {
      if (isNumber(item['134'])) {
        chartData.push([
          moment(item.date).format('LLL'),
          round(Number(item['134']) * rpmMultiplier, 0),
        ])
      }
    })
  let series
  let plotLines
  if (!disableCalibration) {
    series = [
      {
        turboThreshold: 6000,
        name: 'RPM',
        data: chartData,
        type: 'spline',
      },
      {
        name: formatMessage({
          id: 'setting.windMachine.calibrate1',
          defaultMessage: 'Warm Up Value',
          description: 'Calibrate 1 label',
        }),
        type: 'scatter',
        marker: {
          enabled: false,
        },
        showInLegend: false,
        data: [calibrate1],
      },
      {
        name: formatMessage({
          id: 'setting.windMachine.calibrate2',
          defaultMessage: 'Full Run Value',
          description: 'Calibrate 2 label',
        }),
        type: 'scatter',
        marker: {
          enabled: false,
        },
        showInLegend: false,
        data: [calibrate2],
      },
    ]
    plotLines = [
      {
        label: {
          text: formatMessage({
            id: 'setting.windMachine.calibrate1',
            defaultMessage: 'Warm Up Value',
            description: 'Calibrate 1 label',
          }),
          align: 'right',
          y: 20,
        },
        value: calibrate1,
        zIndex: 5,
        width: 2,
        color: '#ff0000',
      },
      {
        label: {
          text: formatMessage({
            id: 'setting.windMachine.calibrate2',
            defaultMessage: 'Full Run Value',
            description: 'Calibrate 2 label',
          }),
          align: 'right',
          y: 20,
        },
        value: calibrate2,
        zIndex: 5,
        width: 2,
        color: '#ff0000',
      },
    ]
  } else {
    series = [
      {
        turboThreshold: 6000,
        name: 'RPM',
        data: chartData,
        type: 'spline',
      },
    ]
    plotLines = []
  }

  return (
    <HighchartsReact
      highcharts={Highcharts}
      options={{
        accessibility: {
          enabled: false,
        },
        title: {
          text: '',
        },
        tooltip: {
          xDateFormat: '%b %e %H:%M',
          shared: true,
        },
        xAxis: {
          lineWidth: 0,
          minorGridLineWidth: 0,
          labels: {
            enabled: false,
          },
          minorTickLength: 0,
          tickLength: 0,
        },
        yAxis: [
          {
            // Primary yAxis
            labels: {
              format: '{value}',
            },
            title: {
              text: '',
            },
            plotLines,
          },
        ],
        series,
        colors: ['#23ce6b'],
        exporting: {
          enabled: false,
        },
        credits: {
          enabled: false,
        },
      }}
    />
  )
}

function WindMachine (props) {
  const {
    device,
    deviceReading,
    setValidity,
    intl: { formatMessage },
  } = props

  const defaultSettings = { settings: { ...DEFAULT_SETTINGS } }
  const {
    application_settings: applicationSettings = defaultSettings,
    application_settings_new: applicationSettingsNew = defaultSettings,
    physical = DEFAULT_PHYSICAL,
  } = device

  // Initialize state
  const initializeState = useCallback(() => {
    const deviceCalibrateSettings = []
    const testSettings = applicationSettings && applicationSettings.settings
    const testSettingsNew =
      applicationSettingsNew && applicationSettingsNew.settings

    let firstCalibrate1 = 100
    if (
      testSettingsNew &&
      isNumber(applicationSettingsNew.settings.calibrate1) &&
      applicationSettingsNew.status === 'new'
    ) {
      firstCalibrate1 = applicationSettingsNew.settings.calibrate1
    } else if (
      testSettings &&
      isNumber(applicationSettings.settings.calibrate1)
    ) {
      firstCalibrate1 = applicationSettings.settings.calibrate1
    }

    let firstCalibrate2 = 200
    if (
      testSettingsNew &&
      isNumber(applicationSettingsNew.settings.calibrate2) &&
      applicationSettingsNew.status === 'new'
    ) {
      firstCalibrate2 = applicationSettingsNew.settings.calibrate2
    } else if (
      testSettings &&
      isNumber(applicationSettings.settings.calibrate2)
    ) {
      firstCalibrate2 = applicationSettings.settings.calibrate2
    }

    deviceCalibrateSettings.push({
      address: device.address,
      status: 'new',
      settings: {
        calibrate1: Math.round(firstCalibrate1),
        calibrate2: Math.round(firstCalibrate2),
      },
    })

    const timeBeg = moment.utc().add(-2, 'hours').toISOString()
    const timeEnd = moment.utc().toISOString()
    const deviceID = device.address

    const {
      windMachine_make = DEFAULT_PHYSICAL.windMachine_make,
      windMachine_engine = DEFAULT_PHYSICAL.windMachine_engine,
      rpmCalibration = DEFAULT_PHYSICAL.rpmCalibration,
      rpmMultiplier = DEFAULT_PHYSICAL.rpmMultiplier,
      ctmEnabled = DEFAULT_PHYSICAL.ctmEnabled,
    } = physical

    let ctmAvailable = false
    if (
      (windMachine_make === 'Orchard Rite' ||
        windMachine_make === 'Vamco' ||
        windMachine_make === 'Wenatchee') &&
      (windMachine_engine === 'V10' ||
        windMachine_engine === 'V8 6.2' ||
        windMachine_engine === 'V8 7.3' ||
        windMachine_engine === 'CAT 7.1' ||
        windMachine_engine === 'CAT 6.6' ||
        windMachine_engine === 'CAT 4.4')
    ) {
      ctmAvailable = true
    }

    let newState = {
      rpmMultiplier: round(1 / rpmMultiplier, 2),
      windMachine_make,
      windMachine_engine,
      defaultEngine_options: [{ name: 'Select Engine', value: '' }],
      rpmCalibration,
      calibrate1Mult: Math.round(firstCalibrate1 / rpmMultiplier),
      calibrate2Mult: Math.round(firstCalibrate2 / rpmMultiplier),
      deviceCalibrateSettings,
      calibrate1Invalid: false,
      calibrate2Invalid: false,
      showSettings: true,
      timeBeg,
      timeEnd,
      deviceID,
      disableCalibration: false,
      inputErrorCalibrate1: false,
      inputErrorCalibrate2: false,
      inputErrorRpmMultiplier: false,
      ctmEnabled,
      ctmAvailable,
    }

    newState = DefaultEngineOptions(newState, formatMessage)
    return newState
  }, [
    device,
    applicationSettings,
    applicationSettingsNew,
    physical,
    formatMessage,
  ])

  const [state, setState] = useState(() => initializeState())

  const {
    rpmMultiplier,
    windMachine_make,
    windMachine_engine,
    defaultEngine_options,
    rpmCalibration,
    calibrate1Mult,
    calibrate2Mult,
    deviceCalibrateSettings,
    calibrate1Invalid,
    calibrate2Invalid,
    showSettings,
    timeBeg,
    timeEnd,
    deviceID,
    disableCalibration,
    inputErrorCalibrate1,
    inputErrorCalibrate2,
    inputErrorRpmMultiplier,
    ctmEnabled,
    ctmAvailable,
  } = state

  const getNewData = useCallback(() => {
    AppDispatcher.dispatch({
      action: 'get-device-readings',
      timeBeg: state.timeBeg,
      timeEnd: state.timeEnd,
      deviceID: state.deviceID,
      convert: false,
    })
  }, [state.timeBeg, state.timeEnd, state.deviceID])

  const appDispatch = useCallback(() => {
    const { address } = device

    let rpmMultiplierValue = 1 / device.physical.rpmMultiplier

    if (isNumber(state.rpmMultiplier)) {
      rpmMultiplierValue = Number(state.rpmMultiplier)
    }

    if (
      state.inputErrorCalibrate1 ||
      state.inputErrorCalibrate2 ||
      state.inputErrorRpmMultiplier
    ) {
      setValidity(false)
    } else {
      setValidity(true)
    }

    const settings = {
      address,
      status: 'new',
      settings: {
        calibrate1: Math.round(state.calibrate1Mult / rpmMultiplierValue),
        calibrate2: Math.round(state.calibrate2Mult / rpmMultiplierValue),
      },
    }

    const physicals = {
      rpmMultiplier: 1 / rpmMultiplierValue,
      windMachine_make: state.windMachine_make,
      windMachine_engine: state.windMachine_engine,
      rpmCalibration: state.rpmCalibration,
      ctmEnabled: state.ctmEnabled,
    }

    AppDispatcher.dispatch({
      action: 'change-setting',
      setting: settings,
    })

    AppDispatcher.dispatch({
      action: 'change-physical',
      setting: physicals,
    })
  }, [device, state, setValidity])

  useEffect(() => {
    getNewData()
    appDispatch()
    const interval = setInterval(getNewData, 60000)

    return () => {
      clearInterval(interval)
    }
  }, [getNewData, appDispatch])

  const childChange = useCallback(
    (event) => {
      const {
        target: { name, value },
      } = event
      let newValue = value

      switch (name) {
        case 'rpmMultiplier':
          newValue = Number(value)
          break

        case 'ctmEnabled':
          newValue = value
          break

        case 'windMachine_make':
          newValue = value
          break

        case 'windMachine_engine':
          newValue = value
          break

        case 'rpmCalibration':
          newValue = value
          break

        case 'calibrate1Mult':
          newValue = Number(value)
          break

        case 'calibrate2Mult':
          newValue = Number(value)
          break

        case 'speedMultiplierHolder':
          newValue = Number(value)
          break

        case 'periodStart':
          newValue = value
          break

        case 'periodStop':
          newValue = value
          break

        default:
          return
      }

      setState((prevState) => {
        let newState = updateRA(prevState, {
          [name]: { $set: newValue },
        })

        if (name === 'calibrate1Mult') {
          if (value < 0 || value > prevState.calibrate2Mult) {
            newState = updateRA(newState, {
              inputErrorCalibrate1: { $set: true },
            })
          } else {
            newState = updateRA(newState, {
              inputErrorCalibrate1: { $set: false },
            })
          }
        }

        if (name === 'calibrate2Mult') {
          if (value < 0 || value < prevState.calibrate1Mult) {
            newState = updateRA(newState, {
              inputErrorCalibrate2: { $set: true },
            })
          } else {
            newState = updateRA(newState, {
              inputErrorCalibrate2: { $set: false },
            })
          }
        }

        if (name === 'rpmMultiplier') {
          if (value < 0) {
            newState = updateRA(newState, {
              inputErrorRpmMultiplier: { $set: true },
            })
          } else {
            newState = updateRA(newState, {
              inputErrorRpmMultiplier: { $set: false },
            })
          }
        }

        if (name === 'windMachine_make') {
          newState = DefaultEngineOptions(newState, formatMessage)
        }

        if (name === 'periodStart') {
          const periodStart = moment(value).utc().toISOString()
          newState = updateRA(newState, {
            timeBeg: { $set: periodStart },
          })
        } else if (name === 'periodStop') {
          const periodStop = moment(value).utc().toISOString()
          newState = updateRA(newState, {
            timeEnd: { $set: periodStop },
          })
        }

        if (
          name === 'windMachine_make' ||
          name === 'windMachine_engine' ||
          name === 'rpmCalibration'
        ) {
          if (
            (newState.windMachine_make === 'Orchard Rite' ||
              newState.windMachine_make === 'Vamco' ||
              newState.windMachine_make === 'Wenatchee') &&
            (newState.windMachine_engine === 'V10' ||
              newState.windMachine_engine === 'V8 6.2' ||
              newState.windMachine_engine === 'V8 7.3' ||
              newState.windMachine_engine === 'CAT 7.1' ||
              newState.windMachine_engine === 'CAT 6.6' ||
              newState.windMachine_engine === 'CAT 4.4')
          ) {
            newState = updateRA(newState, {
              ctmAvailable: { $set: true },
            })
          } else {
            newState = updateRA(newState, {
              ctmAvailable: { $set: false },
            })
          }

          if (
            newState.windMachine_make === 'Orchard Rite' &&
            newState.windMachine_engine === '454/460' &&
            newState.rpmCalibration === 'Default'
          ) {
            newState = updateRA(newState, {
              calibrate1Mult: { $set: 50 * 14 },
              calibrate2Mult: { $set: 100 * 14 },
              rpmMultiplier: { $set: 14 },
              disableCalibration: { $set: false },
            })
          } else if (
            newState.windMachine_make === 'Orchard Rite' &&
            newState.windMachine_engine === 'V10' &&
            newState.rpmCalibration === 'Default'
          ) {
            if (newState.ctmEnabled === 'CTM') {
              newState = updateRA(newState, {
                calibrate1Mult: { $set: 500 },
                calibrate2Mult: { $set: 1500 },
                rpmMultiplier: { $set: 1 },
                disableCalibration: { $set: false },
              })
            } else {
              newState = updateRA(newState, {
                calibrate1Mult: { $set: 500 * 1.53 },
                calibrate2Mult: { $set: 1500 * 1.53 },
                rpmMultiplier: { $set: 1.53 },
                disableCalibration: { $set: false },
              })
            }
          } else if (
            newState.windMachine_make === 'Orchard Rite' &&
            newState.windMachine_engine === 'V8 6.2' &&
            newState.rpmCalibration === 'Default'
          ) {
            newState = updateRA(newState, {
              calibrate1Mult: { $set: 765 },
              calibrate2Mult: { $set: 2000 },
              rpmMultiplier: { $set: 1.0 },
              disableCalibration: { $set: false },
            })
          } else if (
            newState.windMachine_make === 'Orchard Rite' &&
            newState.windMachine_engine === 'CAT 7.1' &&
            newState.rpmCalibration === 'Default'
          ) {
            if (newState.ctmEnabled === 'CTM') {
              newState = updateRA(newState, {
                calibrate1Mult: { $set: 800 },
                calibrate2Mult: { $set: 1900 },
                rpmMultiplier: { $set: 1 },
                disableCalibration: { $set: false },
              })
            } else {
              newState = updateRA(newState, {
                calibrate1Mult: { $set: 800 },
                calibrate2Mult: { $set: 1900 },
                rpmMultiplier: { $set: 0.85 },
                disableCalibration: { $set: false },
              })
            }
          } else if (
            newState.windMachine_make === 'Orchard Rite' &&
            newState.windMachine_engine === 'V8 7.3' &&
            newState.rpmCalibration === 'Default'
          ) {
            if (newState.ctmEnabled === 'CTM') {
              newState = updateRA(newState, {
                calibrate1Mult: { $set: 500 },
                calibrate2Mult: { $set: 1500 },
                rpmMultiplier: { $set: 1 },
                disableCalibration: { $set: false },
              })
            }
          } else if (
            newState.windMachine_make === 'Frost Boss' &&
            newState.windMachine_engine === 'Diesel' &&
            newState.rpmCalibration === 'Default'
          ) {
            newState = updateRA(newState, {
              calibrate1Mult: { $set: 1400 * 0.85 },
              calibrate2Mult: { $set: 1900 * 0.85 },
              rpmMultiplier: { $set: 0.85 },
              disableCalibration: { $set: false },
            })
          } else if (
            newState.windMachine_make === 'Chinook' &&
            newState.windMachine_engine === 'JCB' &&
            newState.rpmCalibration === 'Default'
          ) {
            newState = updateRA(newState, {
              calibrate1Mult: { $set: 500 * 1 },
              calibrate2Mult: { $set: 1500 * 1 },
              rpmMultiplier: { $set: 1 },
              disableCalibration: { $set: false },
            })
          } else if (
            newState.windMachine_make === 'Chinook' &&
            newState.windMachine_engine === 'V10' &&
            newState.rpmCalibration === 'Default'
          ) {
            newState = updateRA(newState, {
              calibrate1Mult: { $set: 500 * 1 },
              calibrate2Mult: { $set: 1500 * 1 },
              rpmMultiplier: { $set: 1 },
              disableCalibration: { $set: false },
            })
          } else if (
            newState.windMachine_make === 'Chinook' &&
            newState.windMachine_engine === 'V8 7.3' &&
            newState.rpmCalibration === 'Default'
          ) {
            newState = updateRA(newState, {
              calibrate1Mult: { $set: 765 * 1 },
              calibrate2Mult: { $set: 2000 * 1 },
              rpmMultiplier: { $set: 1 },
              disableCalibration: { $set: false },
            })
          } else if (
            newState.windMachine_make === 'Chinook' &&
            newState.windMachine_engine === 'IVECO' &&
            newState.rpmCalibration === 'Default'
          ) {
            newState = updateRA(newState, {
              calibrate1Mult: { $set: 500 * 0.85 },
              calibrate2Mult: { $set: 1500 * 0.85 },
              rpmMultiplier: { $set: 0.85 },
              disableCalibration: { $set: false },
            })
          } else if (
            newState.windMachine_make === 'Orchard Rite' &&
            newState.windMachine_engine === 'CAT 6.6' &&
            newState.rpmCalibration === 'Default'
          ) {
            if (newState.ctmEnabled === 'CTM') {
              newState = updateRA(newState, {
                calibrate1Mult: { $set: 500 * 1 },
                calibrate2Mult: { $set: 1500 * 1 },
                rpmMultiplier: { $set: 1 },
                disableCalibration: { $set: false },
              })
            } else {
              newState = updateRA(newState, {
                calibrate1Mult: { $set: 500 * 0.6 },
                calibrate2Mult: { $set: 1500 * 0.6 },
                rpmMultiplier: { $set: 0.6 },
                disableCalibration: { $set: false },
              })
            }
          } else if (
            newState.windMachine_make === 'Orchard Rite' &&
            newState.windMachine_engine === 'CAT 4.4' &&
            newState.rpmCalibration === 'Default'
          ) {
            newState = updateRA(newState, {
              calibrate1Mult: { $set: 800 * 1 },
              calibrate2Mult: { $set: 1400 * 1 },
              rpmMultiplier: { $set: 1 },
              disableCalibration: { $set: false },
            })
          } else if (
            newState.windMachine_make === 'Wenatchee' &&
            newState.windMachine_engine === 'V10' &&
            newState.rpmCalibration === 'Default'
          ) {
            if (newState.ctmEnabled === 'CTM') {
              newState = updateRA(newState, {
                calibrate1Mult: { $set: 500 * 1 },
                calibrate2Mult: { $set: 1500 * 1 },
                rpmMultiplier: { $set: 1 },
                disableCalibration: { $set: false },
              })
            } else {
              newState = updateRA(newState, {
                calibrate1Mult: { $set: 500 * 1.53 },
                calibrate2Mult: { $set: 1500 * 1.53 },
                rpmMultiplier: { $set: 1.53 },
                disableCalibration: { $set: false },
              })
            }
          } else if (
            newState.windMachine_make === 'Wenatchee' &&
            newState.windMachine_engine === 'V8 6.2' &&
            newState.rpmCalibration === 'Default'
          ) {
            newState = updateRA(newState, {
              calibrate1Mult: { $set: 765 * 1 },
              calibrate2Mult: { $set: 2000 * 1 },
              rpmMultiplier: { $set: 1 },
              disableCalibration: { $set: false },
            })
          } else if (
            newState.windMachine_make === 'Wenatchee' &&
            newState.windMachine_engine === 'V8 7.3' &&
            newState.rpmCalibration === 'Default'
          ) {
            newState = updateRA(newState, {
              calibrate1Mult: { $set: 765 * 1 },
              calibrate2Mult: { $set: 2000 * 1 },
              rpmMultiplier: { $set: 1 },
              disableCalibration: { $set: false },
            })
          } else if (
            newState.windMachine_make === 'Jackrabbit' &&
            newState.windMachine_engine === 'Standard' &&
            newState.rpmCalibration === 'Default'
          ) {
            newState = updateRA(newState, {
              calibrate1Mult: { $set: 20 * 50 },
              calibrate2Mult: { $set: 30 * 50 },
              rpmMultiplier: { $set: 50 },
              disableCalibration: { $set: false },
            })
          } else if (
            newState.windMachine_make === 'Vamco' &&
            newState.windMachine_engine !== 'V8 7.3' &&
            newState.rpmCalibration === 'Default'
          ) {
            newState = updateRA(newState, {
              calibrate1Mult: { $set: 765 * 1 },
              calibrate2Mult: { $set: 2000 * 1 },
              rpmMultiplier: { $set: 1 },
              disableCalibration: { $set: false },
            })
          } else if (
            newState.windMachine_make === 'Vamco' &&
            newState.windMachine_engine !== 'V10' &&
            newState.rpmCalibration === 'Default'
          ) {
            if (newState.ctmEnabled === 'CTM') {
              newState = updateRA(newState, {
                calibrate1Mult: { $set: 500 * 1 },
                calibrate2Mult: { $set: 1500 * 1 },
                rpmMultiplier: { $set: 1 },
                disableCalibration: { $set: false },
              })
            } else {
              newState = updateRA(newState, {
                calibrate1Mult: { $set: 500 * 1.53 },
                calibrate2Mult: { $set: 1500 * 1.53 },
                rpmMultiplier: { $set: 1.53 },
                disableCalibration: { $set: false },
              })
            }
          } else if (
            newState.windMachine_make === 'Vamco' &&
            newState.windMachine_engine !== 'V8 6.2' &&
            newState.rpmCalibration === 'Default'
          ) {
            newState = updateRA(newState, {
              calibrate1Mult: { $set: 765 * 1 },
              calibrate2Mult: { $set: 2000 * 1 },
              rpmMultiplier: { $set: 1 },
              disableCalibration: { $set: false },
            })
          } else if (
            newState.windMachine_make === 'Vamco' &&
            newState.windMachine_engine !== '454/460' &&
            newState.rpmCalibration === 'Default'
          ) {
            newState = updateRA(newState, {
              calibrate1Mult: { $set: 50 * 14 },
              calibrate2Mult: { $set: 100 * 14 },
              rpmMultiplier: { $set: 14 },
              disableCalibration: { $set: false },
            })
          } else if (
            newState.windMachine_make === 'Amarillo' &&
            newState.windMachine_engine === 'V10' &&
            newState.rpmCalibration === 'Default'
          ) {
            newState = updateRA(newState, {
              calibrate1Mult: { $set: 500 * 1 },
              calibrate2Mult: { $set: 1500 * 1 },
              rpmMultiplier: { $set: 1 },
              disableCalibration: { $set: false },
            })
          } else if (
            newState.windMachine_make === 'Amarillo' &&
            newState.windMachine_engine === 'V8 6.2' &&
            newState.rpmCalibration === 'Default'
          ) {
            newState = updateRA(newState, {
              calibrate1Mult: { $set: 765 * 1 },
              calibrate2Mult: { $set: 2000 * 1 },
              rpmMultiplier: { $set: 1 },
              disableCalibration: { $set: false },
            })
          } else if (
            newState.windMachine_make === 'Amarillo' &&
            newState.windMachine_engine === 'V8 7.3' &&
            newState.rpmCalibration === 'Default'
          ) {
            newState = updateRA(newState, {
              calibrate1Mult: { $set: 765 * 1 },
              calibrate2Mult: { $set: 2000 * 1 },
              rpmMultiplier: { $set: 1 },
              disableCalibration: { $set: false },
            })
          } else if (
            newState.windMachine_make === 'Electric' &&
            newState.windMachine_engine === 'Electric' &&
            newState.rpmCalibration === 'Default'
          ) {
            newState = updateRA(newState, {
              calibrate1Mult: { $set: 300 * 0.1 },
              calibrate2Mult: { $set: 500 * 0.1 },
              rpmMultiplier: { $set: 0.1 },
            })
          } else {
            newState = updateRA(newState, {
              disableCalibration: { $set: false },
            })
          }
        }

        return newState
      })
    },
    [formatMessage]
  )

  useEffect(() => {
    getNewData()
  }, [timeBeg, timeEnd, getNewData])

  useEffect(() => {
    appDispatch()
  }, [
    calibrate1Mult,
    calibrate2Mult,
    windMachine_make,
    windMachine_engine,
    rpmCalibration,
    rpmMultiplier,
    inputErrorCalibrate1,
    inputErrorCalibrate2,
    inputErrorRpmMultiplier,
    ctmEnabled,
    appDispatch,
  ])

  const WINDMACHINE_MAKE = [
    {
      name: formatMessage({
        id: 'setting.windMachine.select.make',
        defaultMessage: 'Select Make',
        description: '',
      }),
      value: '',
    },
    { name: 'Orchard Rite', value: 'Orchard Rite' },
    { name: 'Amarillo', value: 'Amarillo' },
    { name: 'Chinook', value: 'Chinook' },
    { name: 'Wenatchee', value: 'Wenatchee' },
    { name: 'Vamco', value: 'Vamco' },
    { name: 'Jackrabbit', value: 'Jackrabbit' },
    { name: 'Frost Boss', value: 'Frost Boss' },
    { name: 'Electric', value: 'Electric' },
  ]

  const RPM_CALIBRATION = [
    {
      name: formatMessage({
        id: 'setting.windMachine.select.calibration.default',
        defaultMessage: 'Default',
        description: '',
      }),
      value: 'Default',
    },
    {
      name: formatMessage({
        id: 'setting.windMachine.select.calibration.custom',
        defaultMessage: 'Custom',
        description: '',
      }),
      value: 'Custom',
    },
  ]

  const CTM_OPTIONS = [
    {
      name: formatMessage({
        id: 'setting.windMachine.select.noCTM',
        defaultMessage: 'No',
        description: '',
      }),
      value: 'No CTM',
    },
    {
      name: formatMessage({
        id: 'setting.windMachine.select.engine.CTM',
        defaultMessage: 'Yes',
        description: '',
      }),
      value: 'CTM',
    },
  ]

  const dateFormat = (value) => moment(value).format('YYYY-MM-DDTHH:mm:ss')

  return (
    <div>
      <div className={`${styles.inputArea} ${styles.paddedInputArea}`}>
        <section className={styles.heading}>
          <h3>
            <FormattedMessage
              id='setting.windMachine.calibration.label'
              defaultMessage='RPM Calibration'
              description='RPM Calibration label'
            />
          </h3>
        </section>
        <section>
          <h5>
            <FormattedMessage
              id='setting.windMachine.make.label'
              defaultMessage='Wind Machine Make'
              description='Wind Machine Make label'
            />
          </h5>

          <div className={styles.controlNumber}>
            <SelectInput
              value={windMachine_make}
              options={WINDMACHINE_MAKE}
              childChange={childChange}
              field='windMachine_make'
              style={styles.controlSelectInput}
            />
          </div>
        </section>
        <br />
        <section>
          <h5>
            <FormattedMessage
              id='setting.windMachine.engine.label'
              defaultMessage='Wind Machine Engine Type'
              description='Wind Machine Engine label'
            />
          </h5>

          <div className={styles.controlNumber}>
            <SelectInput
              value={windMachine_engine}
              options={defaultEngine_options}
              childChange={childChange}
              field='windMachine_engine'
              style={styles.controlSelectInput}
            />
          </div>
        </section>
        <br />
        {ctmAvailable && (
          <section>
            <h5>
              <FormattedMessage
                id='setting.windMachine.ctm.label'
                defaultMessage='CAN bus integration (CTM)'
                description='CTM label'
              />
            </h5>

            <div className={styles.controlNumber}>
              <SelectInput
                value={ctmEnabled}
                options={CTM_OPTIONS}
                childChange={childChange}
                field='ctmEnabled'
                style={styles.controlSelectInput}
              />
            </div>
          </section>
        )}
        <br />
        {!disableCalibration && (
          <section>
            <h5>
              <FormattedMessage
                id='setting.windMachine.calibration.label'
                defaultMessage='RPM Calibration'
                description='RPM Calibration label'
              />
            </h5>

            <div className={styles.controlNumber}>
              <SelectInput
                value={rpmCalibration}
                options={RPM_CALIBRATION}
                childChange={childChange}
                field='rpmCalibration'
                style={styles.controlSelectInput}
              />
            </div>
          </section>
        )}
      </div>

      {rpmCalibration === 'Custom' && (
        <div>
          <div className={`${styles.inputArea} ${styles.paddedInputArea}`}>
            <section className={styles.heading}>
              <h3>
                <FormattedMessage
                  id='setting.windMachine.custom.calibration.label'
                  defaultMessage='Customize Calibration'
                  description='Customize Calibration label'
                />
              </h3>
              <h5 className={`${styles.windMachineCalibrationWarning}`}>
                <FormattedMessage
                  id='setting.windMachine.warning.calibration'
                  defaultMessage="WARNING: Customizing engine calibration should only be done in rare cases where you've installed an Altrac device on a non-standard engine. If you have installed the device on a make and model above, please return to default calibration."
                  description='Warning Calibration label'
                />
              </h5>
              <br />
              <h5>
                <FormattedMessage
                  id='setting.windMachine.custom.multiplier.text.label'
                  defaultMessage='Adjust Speed Multiplier until it matches actual RPM on wind machine panel.'
                  description='Customize Multiplier Text label'
                />
              </h5>
            </section>
            <br />
            <section>
              <h5>
                <FormattedMessage
                  id='setting.windMachine.speedmultiplier'
                  defaultMessage='Speed Multiplier'
                  description='Speed Multiplier label'
                />
              </h5>
              <div
                className={`${styles.controlNumber} ${
                  inputErrorRpmMultiplier && styles.inputIssue
                }`}
              >
                <DecimalInput
                  value={rpmMultiplier}
                  childChange={childChange}
                  field='rpmMultiplier'
                  min={0}
                  style={styles.controlNumberInput}
                />
              </div>
            </section>
            <br />
            <section className={styles.heading}>
              <h5>
                <FormattedMessage
                  id='setting.windMachine.custom.calibration.text.label'
                  defaultMessage='To set a custom RPM calibration, run your Wind Machine through a full run cycle that includes engine off, warm up, full run and cool down. Set "Warm Up Value" below to a number 10-20% below the engines warm up speed. Set "Full Run Value" below to a number between warm up speed and full run speed. When this is done correctly, the red line for warm up value will appear between engine off and warm up speed and the red line for full run value will appear between warm up speed and full run speed.'
                  description='Customize Calibration Text label'
                />
              </h5>
            </section>
            <br />

            <section>
              <h5>
                <FormattedMessage
                  id='setting.windMachine.calibrate1'
                  defaultMessage='Warm Up Value'
                  description='Calibrate 1 label'
                />
              </h5>
              <div
                className={`${styles.controlNumber} ${
                  inputErrorCalibrate1 && styles.inputIssue
                }`}
              >
                <DecimalInput
                  value={calibrate1Mult}
                  childChange={childChange}
                  field='calibrate1Mult'
                  min={1}
                  max={calibrate2Mult}
                  style={styles.controlNumberInput}
                />
              </div>
              <h6>
                <FormattedMessage
                  id='setting.windMachine.warning.message'
                  defaultMessage='* Note: This value may change on save due to rounding errors'
                  description='Warning label'
                />
              </h6>
            </section>
            <br />
            <section>
              <h5>
                <FormattedMessage
                  id='setting.windMachine.calibrate2'
                  defaultMessage='Full Run Value'
                  description='Calibrate 2 label'
                />
              </h5>
              <div
                className={`${styles.controlNumber} ${
                  inputErrorCalibrate2 && styles.inputIssue
                }`}
              >
                <DecimalInput
                  value={calibrate2Mult}
                  childChange={childChange}
                  field='calibrate2Mult'
                  min={1}
                  style={styles.controlNumberInput}
                />
              </div>
              <h6>
                <FormattedMessage
                  id='setting.windMachine.warning.message'
                  defaultMessage='* Note: This value may change on save due to rounding errors'
                  description='Warning label'
                />
              </h6>
            </section>
            <br />
            <br />
            <div
              className={stylesTele.dateInputs}
              style={{ marginBottom: '25px' }}
            >
              <input
                type='datetime-local'
                name='periodStart'
                value={dateFormat(timeBeg)}
                onChange={childChange}
              />
              <input
                type='datetime-local'
                name='periodStop'
                value={dateFormat(timeEnd)}
                onChange={childChange}
              />
            </div>
            <Graph
              deviceReading={deviceReading}
              calibrate1={calibrate1Mult}
              calibrate2={calibrate2Mult}
              disableCalibration={disableCalibration}
              rpmMultiplier={rpmMultiplier}
              formatMessage={formatMessage}
            />
          </div>
        </div>
      )}
    </div>
  )
}

WindMachine.propTypes = {
  device: PropTypes.object.isRequired,
  deviceReading: PropTypes.array.isRequired,
  setValidity: PropTypes.func.isRequired,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
}

export default injectIntl(WindMachine)
